module.exports = __webpack_public_path__ + "static/img/5.930733f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/5.png
// module id = gWga
// module chunks = 0